import type { ReactNode } from 'react';
import { previewReturnUrl } from '../returnTo';
import Logo240 from './Logo240';

export default function ObjectivesHeader({ headerAction, onToolsListOpened }: {
  headerAction?: ReactNode;
  onToolsListOpened: () => void;
}) {
  return (
      <header className="preview-nav">
        <a className="preview-nav-logo" href="https://labs.240.org" title="240 Labs" aria-label="240 Labs home">
          <Logo240 className="preview-nav-mark" aria-hidden="true" focusable="false" />
          <span className="preview-nav-name">Standard Checker</span>
        </a>
        <div className="preview-nav-cluster">
          <a className="preview-labs" href={previewReturnUrl(window.location.search)}
            onClick={onToolsListOpened} aria-label="240 Labs">
          <svg className="preview-labs-icon" aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
            <path d="M20 3v4" /><path d="M22 5h-4" /><path d="M4 17v2" /><path d="M5 18H3" />
          </svg>
          <span className="preview-labs-word">Labs</span>
          </a>
          <span className="ph-no-capture">{headerAction}</span>
        </div>
      </header>
  );
}
